import styled from 'styled-components/macro';

const WidgetCode = styled.div`
  width: 100%;
  padding: 10px;
  border-radius: 4px;
  border: solid 1px rgba(255, 255, 255, 0.4);
  resize: none;
  font-family: 'PT Mono', monospace;
  font-size: 16px;
`;

export default WidgetCode;
